import t from 'react-translate';
import {
  RecordingFormat
  ,
} from 'redux/schemas/models/video-practice';
import { MediaSourceType, requestMediaStream } from 'recording/services/media-stream';
import { useAppDispatch } from 'redux/store';
import { openConfirmationDialog } from 'redux/actions/confirmation-dialogs';


import { RecordMode } from '../practice-activity-modal';

import { config as appConfig } from '@config/config.json';

export const CAMERA_SETTINGS_ARTICLE_LINK = `${appConfig.helpLink}/article/ART-1787`;

const useGetMediaStream = (mode, recordingFormat) => {
  const dispatch = useAppDispatch();

  const getMediaStream = () => {
    // setMediaStream(null);

    let mediaStreamType = MediaSourceType.MIC;
    if (recordingFormat === RecordingFormat.VIDEO) {
      mediaStreamType = mode === RecordMode.SCREEN ? MediaSourceType.SCREEN_MIC : MediaSourceType.CAMERA_MIC;
    }
    return requestMediaStream(mediaStreamType).catch(error => {
      if (mode === RecordMode.SCREEN) {
        if (error.type === 'audio' && error.name === 'NotFoundError') {
          dispatch(openConfirmationDialog({
            confirmButtonVariant: 'primary',
            title: t.FILE_UPLOAD.CANNOT_RECORD.TITLE(),
            bodyText: t.FILE_UPLOAD.CANNOT_RECORD.AUDIO_NOT_FOUND(),
            confirmText: t.FORM.CONTINUE(),
            onConfirm: () => getMediaStream(),
          }));
        } else if (error.type === 'audio' && error.name === 'NotAllowedError') {
          dispatch(openConfirmationDialog({
            confirmButtonVariant: 'primary',
            title: t.FILE_UPLOAD.CANNOT_RECORD.TITLE(),
            bodyText: t.FILE_UPLOAD.CANNOT_RECORD.AUDIO_NOT_ALLOWED(CAMERA_SETTINGS_ARTICLE_LINK),
            confirmText: t.FORM.CONTINUE(),
            onConfirm: () => getMediaStream(),
          }));
        } else if (error.name === 'NotAllowedError') {
          dispatch(openConfirmationDialog({
            title: t.FILE_UPLOAD.CANNOT_RECORD.TITLE(),
            bodyText: t.FILE_UPLOAD.CANNOT_RECORD.SCREEN_NOT_ALLOWED(),
            confirmText: t.FORM.CONTINUE(),
            onConfirm: () => getMediaStream(),
          }));
        }
      } else if (error.name === 'NotFoundError') {
        dispatch(openConfirmationDialog({
          title: t.FILE_UPLOAD.CANNOT_RECORD.TITLE(),
          bodyText: t.FILE_UPLOAD.CANNOT_RECORD.VIDEO_NOT_FOUND(),
          confirmText: t.FORM.CONTINUE(),
          onConfirm: () => getMediaStream(),
        }));
      } else if (error.name === 'NotAllowedError') {
        dispatch(openConfirmationDialog({
          title: t.FILE_UPLOAD.CANNOT_RECORD.TITLE(),
          bodyText: t.FILE_UPLOAD.CANNOT_RECORD.VIDEO_NOT_ALLOWED(CAMERA_SETTINGS_ARTICLE_LINK),
          confirmText: t.FORM.CONTINUE(),
          onConfirm: () => getMediaStream(),
        }));
      }
    });
  };

  return getMediaStream;
};

export default useGetMediaStream;
